import NodeDataStore from "csi/datastore/NodeDataStore";
import { getSearch } from "csi/service/dataStoreService";
import { resolveNode } from "csi/service/nodeService";
import WorkingCache from "csi/state/WorkingCache";
import { C8Node } from "csi/typings";
import { getPresentationRuntimeRules, getSetItemDependencyPaths, processProductViolations } from "../PPService";
import ProductGalleryStore, { EditSetCallback } from "./ProductGalleryStore";

/** return store for set items gallery */
export async function getProductGalleryStore(ppset: C8Node, cache: WorkingCache, editSetCallback?: EditSetCallback): Promise<ProductGalleryStore> {
	const presentationUrl = ppset.__Parent__;
	const presentation = await resolveNode(presentationUrl, cache);

	// get the latest violation information
	await processProductViolations(presentation, cache);

	const runtimeRules = await getPresentationRuntimeRules(presentationUrl, cache);
	const filterSpecs = runtimeRules.ruleSpecs.map((ruleSpec) => ruleSpec.spec);
	const paths = getSetItemDependencyPaths(filterSpecs);
	const search = getSearch("ProductPresentationSetItem.ProductPresentationSet", ppset.$URL);
	search.addDependencyPaths(paths);
	const nodeStore = new NodeDataStore(search, cache);

	return new ProductGalleryStore(nodeStore, true, null, presentationUrl, null, null, editSetCallback);
}